import type { FaireProductEntity } from "../../entity_types/product";

export const p_jb7n5a9vvn: FaireProductEntity = {
  token: "p_jb7n5a9vvn",
  type: "product",
  name: "Big Cheese Mode Sensory Toys",
  brandToken: "b_f1bkinpani",
  brandName: "NYSLIFE",
  imageUrl:
    "https://cdn.faire.com/fastly/b2531dc18ddc9011fb0e4177c3769a195e233f154945e7702534b0364b335895.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1fb54367a326abffa8d3a1932743f884f5fdba895cac69aec1d87681aadb72e0.jpeg",
  ],
  priceDollars: 5.75,
  description:
    "1 Order = 36 Pieces (6 Counter Displays)\n\nSquishy Jumbo Cheese Cube \n\nSoft Dough Filled \n\nTextured to imitate cheese",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:38.064Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
